import React, { useState } from 'react';
import {
  Button, CreateButton, FilterButton, FilterContext, TopToolbar,
  fetchRelatedRecords, useDataProvider, useListContext, useNotify,
  useResourceDefinition,
} from 'react-admin';
import DownloadIcon from '@mui/icons-material/GetApp';
import CircularProgress from '@mui/material/CircularProgress';
import { ENTRYPOINT } from '../config/entrypoint';
import { fetchAllExportRecords } from '../helper/fetchAllExportRecords';

export const ExportAllButton = () => {
  const { filter, filterValues, resource, sort, exporter, total } = useListContext();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    setExporting(true);
    try {
      if (!['courses', 'course_city_dates'].includes(resource)) {
        const records = await fetchAllExportRecords(dataProvider, resource, {
          sort: { field: 'id', order: 'ASC', ...sort },
          filter: { ...filterValues, ...filter },
        });
        await exporter(records, fetchRelatedRecords(dataProvider), dataProvider, resource);
        return;
      }
      const response = await fetch(`${ENTRYPOINT}/admin-exports/${encodeURIComponent(resource)}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('auth')}`,
          'Content-Type': 'application/json',
          Accept: 'text/csv',
        },
        body: JSON.stringify({
          sort: { field: 'id', order: 'ASC', ...sort },
          filter: { ...filterValues, ...filter },
        }),
      });
      if (!response.ok) {
        throw new Error(`Export failed (${response.status})`);
      }
      const url = URL.createObjectURL(await response.blob());
      const link = document.createElement('a');
      link.href = url;
      link.download = `${resource}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) {
      console.error(error);
      notify('ra.notification.http_error', { type: 'error' });
    } finally {
      setExporting(false);
    }
  };

  return (
    <Button
      label={exporting ? 'ra.message.loading' : 'ra.action.export'}
      disabled={exporting || total === 0 || exporter === false}
      onClick={handleExport}
      aria-busy={exporting}
    >
      {exporting ? <CircularProgress size={18} color="inherit" /> : <DownloadIcon />}
    </Button>
  );
};

export const ExportAllListActions = () => {
  const filters = React.useContext(FilterContext);
  const { hasCreate } = useResourceDefinition();
  const { exporter } = useListContext();
  return (
    <TopToolbar>
      {filters && <FilterButton />}
      {hasCreate && <CreateButton />}
      {exporter !== false && <ExportAllButton />}
    </TopToolbar>
  );
};
